import { useCart } from "../../../contexts/CartContext";

export default function OrderSummary() {
  const { items, totalPrice, originalTotalPrice, savedAmount, updateQuantity, removeItem } = useCart();

  return (
    <div className="bg-[#FAFAFA] rounded-lg p-6 sticky top-24">
      <h2 className="text-lg font-semibold text-[#1B4332] mb-6">訂單摘要</h2>

      {/* Items */}
      <div className="space-y-4 mb-6 max-h-80 overflow-y-auto pr-1"
        style={{ scrollbarWidth: "thin", scrollbarColor: "#d4d4d8 transparent" }}
      >
        {items.map(({ product, quantity }) => (
          <div key={product.id} className="flex items-start gap-3">
            <div className="w-14 h-14 flex-shrink-0 bg-white rounded overflow-hidden border border-zinc-100">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-zinc-400 tracking-wider uppercase mb-0.5">{product.brand}</p>
              <p className="text-sm text-[#1B4332] font-medium line-clamp-1">{product.name}</p>
              <div className="flex items-center gap-2 mt-1.5">
                <button
                  onClick={() => updateQuantity(product.id, quantity - 1)}
                  className="w-6 h-6 flex items-center justify-center border border-zinc-200 rounded text-zinc-500 hover:border-zinc-500 cursor-pointer text-xs"
                >
                  <i className={quantity === 1 ? "ri-delete-bin-line" : "ri-subtract-line"}></i>
                </button>
                <span className="text-xs text-[#1B4332] w-5 text-center">{quantity}</span>
                <button
                  onClick={() => updateQuantity(product.id, quantity + 1)}
                  className="w-6 h-6 flex items-center justify-center border border-zinc-200 rounded text-zinc-500 hover:border-zinc-500 cursor-pointer text-xs"
                >
                  <i className="ri-add-line"></i>
                </button>
                <button
                  onClick={() => removeItem(product.id)}
                  className="ml-auto text-zinc-300 hover:text-red-400 cursor-pointer"
                >
                  <i className="ri-close-line text-sm"></i>
                </button>
              </div>
            </div>
            <div className="flex-shrink-0 text-right">
              <p className="text-sm font-semibold text-[#1B4332]">
                NT$ {(product.price * quantity).toLocaleString()}
              </p>
              {quantity > 1 && (
                <p className="text-xs text-zinc-400">
                  × {quantity}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Divider */}
      <div className="border-t border-zinc-200 pt-4 space-y-2 mb-4">
        <div className="flex justify-between text-sm text-zinc-500">
          <span>商品小計</span>
          <span>NT$ {originalTotalPrice.toLocaleString()}</span>
        </div>
        {savedAmount > 0 && (
          <div className="flex justify-between text-sm text-emerald-600">
            <span>折扣優惠</span>
            <span>-NT$ {savedAmount.toLocaleString()}</span>
          </div>
        )}
        <div className="flex justify-between text-sm text-zinc-500">
          <span>運費</span>
          <span className="text-emerald-600">免運</span>
        </div>
      </div>

      {/* Total */}
      <div className="border-t-2 border-[#1B4332] pt-4 flex justify-between items-center">
        <span className="font-semibold text-[#1B4332]">總計</span>
        <span className="text-2xl font-bold text-[#1B4332]">
          NT$ {totalPrice.toLocaleString()}
        </span>
      </div>

      {/* Security */}
      <div className="mt-6 flex flex-col gap-2">
        {["ri-shield-check-line 原廠保固，品質保證", "ri-truck-line 全台免運費配送", "ri-exchange-line 7 天無憂退換"].map((item) => {
          const [icon, text] = item.split(" ");
          return (
            <div key={text} className="flex items-center gap-2 text-zinc-400 text-xs">
              <i className={`${icon} text-sm`}></i>
              <span>{text}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
